import { render, staticRenderFns } from "./formLayout.vue?vue&type=template&id=f3a1e4fa&scoped=true"
import script from "./formLayout.vue?vue&type=script&lang=js"
export * from "./formLayout.vue?vue&type=script&lang=js"
import style0 from "./formLayout.vue?vue&type=style&index=0&id=f3a1e4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a1e4fa",
  null
  
)

export default component.exports